<template>
  <div v-if="hasValue" qaid="serial-search-results">
    <p class="text-md mb-2" v-html="bp('serialLookup.B2B.matchingBike')" />
    <table class="b2b-table b2b-table--compact w-auto mb-2">
      <thead>
        <tr>
          <th v-html="bp('text.model')" />
          <th v-html="bp('contactUs.year')" />
          <th v-html="bp('product.variants.colour')" />
          <th v-html="bp('product.variants.size')" />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-html="value.model" />
          <td v-html="value.year" />
          <td v-html="value.color" />
          <td v-html="value.size" />
        </tr>
      </tbody>
    </table>
    <div class="buttons">
      <trek-button
        qaid="serial-search-view-bike-button"
        type="submit"
        variants="primary"
        @click="navigateToProduct"
        v-html="bp('text.viewBike')"
      />
    </div>
  </div>
</template>
<script>
import {Url} from '@/utils/url';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'TechInfoSerialSearchResults',
  components: {TrekButton},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasValue() {
      return this.value && Object.keys(this.value).length > 0;
    },
  },
  methods: {
    navigateToProduct() {
      window.location.href = Url.withContextPath(this.value.url);
    },
  },
};
</script>
